/* eslint-disable @reatom/unit-naming-rule */

import { action, atom, onConnect } from '@reatom/framework'

import { reatomWalletSwapInput } from './reatom-wallet-swap-input'
import { reatomWalletSwapPair } from './reatom-wallet-swap-pair'
import { processWalletSwapAction } from './reatom-wallet-swap-process'
import { reatomWalletSwapQuote } from './reatom-wallet-swap-quote'
import { reatomWalletSwapSettings } from './reatom-wallet-swap-settings'
import { reatomWalletSwapValidation } from './reatom-wallet-swap-validation'

import type { WalletModel } from '@root/entities/wallet'

export const reatomWalletSwap = (wallet: WalletModel) => {
  const triggerAtom = atom(undefined, 'triggerAtom')

  const swapInputModel = reatomWalletSwapInput(wallet)
  const swapPairModel = reatomWalletSwapPair(swapInputModel)
  const swapValidationModel = reatomWalletSwapValidation(
    swapInputModel,
    swapPairModel,
  )
  const settingsModel = reatomWalletSwapSettings()
  const swapQuoteModel = reatomWalletSwapQuote(
    swapInputModel,
    swapPairModel,
    settingsModel,
    wallet,
  )

  onConnect(triggerAtom, (ctx) => {
    const subscriptions = [
      swapQuoteModel.watchQuoteStateReaction(ctx),
      swapPairModel.currenciesChangeReaction(ctx),
      swapPairModel.poolsStateReaction(ctx),
    ]
    return () => {
      for (const it of subscriptions) {
        it.unsubscribe()
      }
    }
  })

  const executeSwapAction = action(async (ctx) =>
    processWalletSwapAction(ctx, {
      inputModel: swapInputModel,
      settingsModel: settingsModel,
      pairModel: swapPairModel,
      quoteModel: swapQuoteModel,
      wallet: wallet,
    }),
  )

  return {
    triggerAtom,
    input: swapInputModel,
    quote: swapQuoteModel,
    pair: swapPairModel,
    validation: swapValidationModel,
    settings: settingsModel,
    swapQuoteModel,
    executeSwapAction,
  }
}

export type WalletSwapModel = ReturnType<typeof reatomWalletSwap>
